/** dragstart 이벤트에서 beginMoveDrag 가 읽는 부분 — React DragEvent 가 그대로 맞는다. */
export interface MoveDragStartEvent {
  readonly target: EventTarget;
  readonly currentTarget: EventTarget;
  readonly dataTransfer: Pick<DataTransfer, 'setData' | 'effectAllowed'>;
}

/**
 * 끌어서 순서를 바꾸는 항목의 dragstart 공통 처리. 이 항목을 옮기는 끌기를 시작했으면 true 를 돌려준다.
 *
 * - 안쪽 요소에서 시작한 끌기는 옮기기가 아니다 — 이름 수정 입력칸에서 고른 글자를 끌면 항목이
 *   draggable=false 여도 dragstart 가 위로 올라온다. 이때는 끌리는 글자를 id 로 덮어쓰지 않고 false 다.
 * - Firefox 는 dragstart 에서 dataTransfer.setData 를 부르지 않으면 끌기를 시작하지 않는다 —
 *   끌리는 항목의 id 를 text/plain 으로 싣고, 옮기기(move) 끌기임을 알린다.
 */
export const beginMoveDrag = (event: MoveDragStartEvent, id: string): boolean => {
  if (event.target !== event.currentTarget) {
    return false;
  }

  event.dataTransfer.setData('text/plain', id);
  event.dataTransfer.effectAllowed = 'move';
  return true;
};
